<script setup lang="ts">
import { computed } from 'vue'
import { useAccessStore } from '@/stores/access'
import { useRoute, useRouter } from 'vue-router'

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import RolesTable from '@/components/roles/RolesTable.vue'
import type { Kind } from '@/utils/accessDomains'

const accessStore = useAccessStore()
const route = useRoute()
const router = useRouter()

const loaded = computed(() => accessStore.loaded)
const kind = computed<Kind>(() => (route.query.scope === 'project' ? 'project' : 'org'))

const setKind = (value: string | number) => {
  router.replace({ query: { ...route.query, scope: String(value) } })
}
</script>

<template>
  <div v-if="loaded">
    <Tabs :model-value="kind" class="mb-4" @update:model-value="setKind">
      <TabsList>
        <TabsTrigger value="org">Organization roles</TabsTrigger>
        <TabsTrigger value="project">Project roles</TabsTrigger>
      </TabsList>
    </Tabs>

    <RolesTable :key="kind" :kind="kind" />
  </div>
</template>
